import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL+'/api', 
});

axiosInstance.interceptors.request.use(
    (config) => {
      // Retrieve the token from localStorage, sessionStorage, or any other storage
      const token = localStorage.getItem('authToken'); // Use your preferred storage method
  
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // config.headers['ngrok-skip-browser-warning'] = 'wow'; 
  
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // clear auth token
       localStorage.clear();
       window.location.href = `${process.env.REACT_APP_CAS_BASE_URL}/logout`;
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;